import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "toolkit/store";
import { checkCompletingReferences } from "toolkit/references/references.thunks";
import { LongEmployeeListingResponse } from "libs/apiClient/data-contracts";
import { employeesAPI } from "libs/apiClient/Employees";
import { organizationsAPI } from "libs/apiClient/Organizations";
import { employeeAPI } from "libs/apiClient/Employee";
import { snackWrapper } from "helpers";
import { userAPI } from "libs/apiClient/User";

interface IParamsGetEmployyee {
	query?: string;
	org?: number;
	filter_column?: string;
	filter_value?: string;
	change: boolean;
	select: boolean;
}
export const getAllEmployees = createAsyncThunk(
	"employeesSlice/getAllEmployees",
	async (params: IParamsGetEmployyee, { rejectWithValue, dispatch }) => {
		try {
			const { change, select } = params;
			let res: LongEmployeeListingResponse & { change?: boolean };

			if (select) {
				res = await employeesAPI.longUnboundList({ page: 1, num: 999999 }).then((r) => r.data);
			} else {
				res = await employeesAPI.longList({ page: 1, num: 999999 }).then((r) => r.data);
			}

			res = {
				...res,
				change,
			};

			dispatch(checkCompletingReferences());

			return res;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
export const changeActiveFilter = createAsyncThunk(
	"employeesSlice/changeActiveFilter",
	async ({ archive, params, item }: any, { rejectWithValue, getState }) => {
		try {
			// params.change = false;
			// const { filter_column, filter_value, ...restParams } = params;
			const state: any = (getState() as RootState).employess;
			// setPositionDepartment(prevState => prevState)
			const newFilters: typeof state.employeesFilters = {
				department: [],
				status: [],
				relationship: [],
				position: [],
			};
			let key: keyof typeof state.employeesFilters;
			for (key in state.employeesFilters) {
				let arr = state.employeesFilters[key];
				if (key === item.column) {
					newFilters[key] = [...arr].map((_) =>
						_.id === item.id
							? {
									..._,
									active: true,
							  }
							: { ..._, active: false },
					);
				} else {
					newFilters[key] = [...arr].map((_) => (_.id === 0 ? { ..._, active: true } : { ..._, active: false }));
				}
			}
			// const depart = newFilters.department.find((_: any) => _.active);
			// const st = newFilters.status.find((_: any) => _.active);
			// const pos = newFilters.position.find((_: any) => _.active);
			// const relation = newFilters.relationship.find((_: any) => _.active);
			// let par: any = {};
			// if (depart && depart.column) {
			// 	if (depart.id !== 0) {
			// 		par = { filter_column: depart.column, filter_value: depart.name };
			// 	}
			// }
			// if (st && st.column) {
			// 	if (st.id !== 0) {
			// 		par = { filter_column: st.column, filter_value: st.name };
			// 	}
			// }
			// if (relation && relation.column) {
			// 	if (relation.id !== 0) {
			// 		par = { filter_column: relation.column, filter_value: relation.name };
			// 	}
			// }
			// if (pos && pos.column) {
			// 	if (pos.id !== 0) {
			// 		par = { filter_column: pos.column, filter_value: pos.name };
			// 	}
			// }
			// if (archive) {
			// 	dispatch(
			// 		getAcriveEmployees({
			// 			...restParams,
			// 			...(isEmpty(par) ? {} : { ...par }),
			// 		}),
			// 	);
			// } else {
			// 	dispatch(
			// 		getAllEmployees({
			// 			...restParams,
			// 			...(isEmpty(par) ? {} : { ...par }),
			// 		}),
			// 	);
			// }
			return newFilters;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getAcriveEmployees = createAsyncThunk(
	"employeesSlice/getAcriveEmployees",
	async (params: IParamsGetEmployyee, { rejectWithValue }) => {
		try {
			const { change } = params;
			return {
				...(await employeesAPI.longList({ page: 1, num: 9999999999, ...params }).then((r) => r.data)),
				change,
			};
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getOrganizationEmployees = createAsyncThunk(
	"employeesSlice/getOrganizationEmployees",
	async (organizationId: number, { rejectWithValue }) => {
		try {
			return organizationsAPI.employeesDetail(organizationId, { part: 1, count: 50 }).then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const archiveEmployee = createAsyncThunk(
	"employeesSlice/archiveEmployee",
	async (employeeId: number, { rejectWithValue }) => {
		try {
			await employeeAPI.archiveDetail(String(employeeId));
			snackWrapper("success", "Сотрудник успешно архивирован");
			return employeeId;
		} catch ({ message }) {
			snackWrapper("success", "Не удалось архивировать сотрудника");
			return rejectWithValue(message);
		}
	},
);

export const deleteFromArchiveEmployee = createAsyncThunk(
	"employeesSlice/deleteFromArchiveEmployee",
	async (employeeId: number, { rejectWithValue }) => {
		try {
			await employeeAPI.archiveDelete(String(employeeId));
			snackWrapper("success", "Сотрудник успешно восстановлен");
			return employeeId;
		} catch ({ message }) {
			snackWrapper("success", "Не удалось восстановить сотрудника");
			return rejectWithValue(message);
		}
	},
);

export const getOrganizationsName = createAsyncThunk(
	"employeesSlice/getOrganizationsName",
	async (_, { rejectWithValue }) => {
		try {
			return await organizationsAPI.allSimpleList({ page: 1, num: 9999999 }).then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getEmployee = createAsyncThunk(
	"employeesSlice/getEmployee",
	async (params: { userId?: string; employeeId?: string }, { rejectWithValue }) => {
		try {
			return userAPI.profileList({ userid: +params.userId!, employeeid: +params.employeeId! }).then((r) => r.data);
			// return (await $api.get(`/user/profile`, { params })).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
